import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';

function Home() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <section className="px-4 pb-16 pt-24">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 text-center">
        <div className="inline-flex items-center rounded-full border border-cyan-400/30 bg-cyan-400/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-cyan-200">
          Disc Golf Event Platform
        </div>        

        <div
          className="relative w-full overflow-hidden rounded-[32px] border border-white/10 bg-slate-900 shadow-[0_30px_80px_-25px_rgba(15,23,42,0.7)]"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/P7140400.JPG)`, backgroundPosition: 'center', backgroundSize: 'cover' }}
        >
          <div className="absolute inset-0 bg-slate-950/55" />
          <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(15,23,42,0.85),rgba(15,23,42,0.35))]" />

          <div className="relative px-6 py-5 md:px-12 md:py-14">
            <p className="text-sm font-semibold uppercase tracking-[0.45em] text-yellow-300">Disc Golf</p>

            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="Disc Golf Reikäpeli Cup"
              className="mx-auto mt-4 w-full max-w-[100px] drop-shadow-[0_12px_30px_rgba(15,23,42,0.45)]"
            />

            <h1 className="mt-4 text-4xl font-black tracking-tight text-white md:text-6xl xl:text-7xl">
              Reikäpeli Cup
            </h1>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Button name="Katso kisat" type="PRIMARY" action={() => navigate('/kisat')} />            
            </div>
          </div>
        </div>

      </div>

      <p className="pointer-events-none fixed bottom-3 right-4 z-20 text-xs font-semibold text-slate-200/90 drop-shadow-[0_2px_6px_rgba(15,23,42,0.9)]">
        &copy; {currentYear} Wirmo DiscGolf Mynämäki ry
      </p>
    </section>
  );
}

export default Home;
